module.exports = "/_next/static/images/customer-review-sarah2@2x-min-c0646c63c04480a222c0c8aa47150656.png";